export default __webpack_public_path__ + "static/media/mode-auto.565ca766.png";